export const productLines = {
    LoopCAD: {
        name: 'LoopCAD',
        logo: require('@/assets/img/logos/product/loopcad.png'),
        year: 2024,
        page: '/product/loopcad',
        isAnnualSubscription: false,
        options: {
            new: [
                { label: 'Purchase and Activate a new license', value: 'newLicense' },
                { label: 'Activate a pre-purchased license (I have a prepaid code or license key)', value: 'prepaid' },
            ],
            renew: [
                { label: 'Renew my annual subscription', value: 'renew' },
            ],
            upgrade: [
                { label: 'Upgrade to MJ8 Edition', value: 'upgradeMJ8' },
                { label: 'Upgrade to Professional Edition', value: 'upgradePro' },
            ],
            reactivate: [
                { label: 'Activate after a reinstall or after a version upgrade', value: 'reactivate' },
            ]
        },
        sysReq: {
            system: 'Microsoft Windows 11 or 10, with Microsoft .NET Framework 4.8',
            processor: '2.0 GHz or higher recommended',
            memory: '4 GB minimum, 8 GB or more recommended',
            diskspace: '400 MB (Microsoft .NET Framework may require up to 4.5 GB)',
            video: 'SVGA or higher (recommend resolution of 1920 x 1080 or higher). Support for DirectX 11 or OpenGL 2.0(recommend minimum of 1 GB Video Memory)',
            mouse: 'External mouse with scroll wheel (built-in mouse pads are not recommended)',
        },
        features: [
            {
                title: 'Floorplan Drawing',
                description: 'Creating floorplan drawings is very fast using the predefined rooms, doors, windows and other objects. Rooms can be resized by dragging the walls or corners, and they are easily docked together to create complex floor plans. The room shapes can be quickly edited to create very complex shapes, and you can also use the freehand drawing tools to create more complex shapes. LoopCAD also allows you to import an existing AutoCAD*, PDF** or scanned drawings to use as a template.',
                image: require('@/assets/img/content/floorplan-drawings.png'),
            },
            {
                title: 'Automated Circuit Drawing',
                description: 'LoopCAD automatically generates circuits for the rooms in your project. Simply drop a Circuit Entry object where you want the circuits to start, and LoopCAD takes care of the rest. It automatically designs around obstructions, like stairs, cabinets or kitchen islands. Easily edit the settings to change the pattern type, rotation, number of circuits, or tube spacing options. And use the powerful Layout Gallery tool to quickly select the best pattern for your design. For room geometries too complex for automated circuits, the freehand circuit tools let you quickly draw the exact circuits that you want.',
                image: require('@/assets/img/content/automated-circuits.png'),
            },
            {
                title: 'Heat Loss Calculations',
                description: 'LoopCAD provides options for calculating the room-by-room heat losses automatically as you draw your floorplan. You can choose the residential calculation method that best suits your project - ASHRAE, CSA or Manual J. LoopCAD automatically detects rooms above or below, and even supports cold partition calculations between rooms.',
                image: require('@/assets/img/content/heatloss.png'),
            },
            {
                title: 'Cooling Load Calculations',
                description: 'Residential heating and cooling loads calculations are available with options for ACCA Approved Manual J (MJ8 Edition) and Verified CSA F280-12 (Canada). Full support for Manual J 8th Edition cooling loads including block loads, room-by-room loads, infiltration and ventilation loads, detailed exposure diversity analysis, and room CFM estimates.',
                image: require('@/assets/img/content/cooling-loads.png'),
            },
            {
                title: 'ACCA<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>-Approved Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>',
                description: 'LoopCAD MJ8 is ACCA-Approved for Manual J (8th Edition) residential heating and cooling load calculations. This streamlines the acceptance of your submittals by local authorities requiring ACCA-Approved software calculations. <a href="/acca">Click here</a> for more details.',
                image: require('@/assets/img/content/acca-powered.png'),
            },
            {
                title: 'CSA<sup>&reg</sup> F280-12 Residential Heating and Cooling Loads',
                description: 'LoopCAD provides for easy, accurate and verified <span class="bold">CSA F280-12</span> residential heating and cooling load calculations. <a href="/f280">Click here</a> for more details.',
                image: require('@/assets/img/content/f280-verified.png'),
            },
            {
                title: 'Hydronic Calculations',
                description: 'The hydronic calculations that are critical to your radiant system design are performed automatically. And the Radiant Design view provides an easy way to analyze and optimize your design.<ul><li>Panel heat outputs</li><li>Surface temperatures</li><li>Panel temperatures</li><li>Water temperatures - supply and differential</li><li>Flow rates and head losses</li><li>Controllability Issues</li></ul>',
                image: require('@/assets/img/content/hydronic-calcs.png'),
            },
            {
                title: 'Commercial Mode',
                description: 'The Commercial Mode provides powerful new tools for designing your commercial radiant heating projects, including Custom Circuit Areas, custom construction library, and significant performance improvements. Easily divide large areas into multiple smaller Circuit Areas, making the auto-generation of circuits better and faster.',
                image: require('@/assets/img/content/commercial-projects.png'),
            },
            {
                title: 'Snowmelt Design',
                description: 'Snowmelt system design is fully supported in LoopCAD. Draw snowmelt areas, generate circuits, calculate loads and temperatures in much the same way as you do for radiant heating systems. Calculations are based on ASHRAE methods.',
                image: require('@/assets/img/content/snowmelt.png'),
            },
            {
                title: '3D CAD Views',
                description: 'LoopCAD generates 3D views of your building that you draw in 2D. The new 3D views are a powerful aide for ensuring accurate heat load calculations, and are also very effective for communicating your design work. Validation of the placement and sizing of windows, doors and walls is made much faster and more precise with the 3D views.',
                image: require('@/assets/img/content/3dview.png'),
            },
            {
                title: 'OEM Compatibility',
                description: "LoopCAD is available in custom OEM Editions that integrate the systems and components from North America's leading manufacturers (OEMs). Not only can you design your circuit layouts, perform load calculations, and generate all hydronic data, you can also generate a complete materials list from your selected OEM. The OEM's design recommendations and data are also built in to the OEM edition for you.",
                image: require('@/assets/img/content/oem.png'),
            },
        ],
    },
    HeatCAD: {
        name: 'HeatCAD',
        logo: require('@/assets/img/logos/product/heatcad.png'),
        year: 2024,
        page: '/product/heatcad',
        isAnnualSubscription: false,
        options: {
            new: [
                { label: 'Purchase and Activate a new license', value: 'newLicense' },
                { label: 'Activate a pre-purchased license (I have a prepaid code or license key)', value: 'prepaid' },
            ],
            renew: [
                { label: 'Renew my annual subscription', value: 'renew' },
            ],
            upgrade: [
                { label: 'Upgrade to MJ8 Edition', value: 'upgradeMJ8' },
            ],
            reactivate: [
                { label: 'Activate after a reinstall or after a version upgrade', value: 'reactivate' },
            ]
        },
        sysReq: {
            system: 'Microsoft Windows 11 or 10, with Microsoft .NET Framework 4.8',
            processor: '2.0 GHz or higher recommended',
            memory: '4 GB minimum, 8 GB or more recommended',
            diskspace: '250 MB (Microsoft .NET Framework may require up to 4.5 GB)',
            video: 'SVGA or higher (recommend resolution of 1920 x 1080 or higher). Support for DirectX 11 or OpenGL 2.0(recommend minimum of 1 GB Video Memory)',
            mouse: 'External mouse with scroll wheel (built-in mouse pads are not recommended)',
        },
        features: [
            {
                title: 'Floorplan Drawing',
                description: 'Creating floorplan drawings is very fast using the predefined rooms, doors, windows and other objects. Rooms can be resized by dragging the walls or corners, and they are easily docked together to create complex floor plans. The room shapes can be quickly edited to create very complex shapes, and you can also use the freehand drawing tools to create more complex shapes. HeatCAD also allows you to import an existing AutoCAD*, PDF** or scanned drawings to use as a template.',
                image: require('@/assets/img/content/hc-floorplan-drawings.png'),
            },
            {
                title: 'Heat Loss Calculations',
                description: 'HeatCAD calculates the room-by-room heat loss automatically as you draw the floorplan. And you can choose the residential calculation method that best suits your project - ASHRAE, CSA or Manual J. HeatCAD automatically detects rooms above or below and even supports cold partition calculations between rooms.',
                image: require('@/assets/img/content/hc-heatloss.png'),
            },
            {
                title: 'Cooling Load Calculations',
                description: 'Residential heating and cooling loads calculations are available with options for ACCA Approved Manual J (MJ8 Edition) and Verified CSA F280-12 (Canada). Full support for Manual J 8th Edition cooling loads including block loads, room-by-room loads, infiltration and ventilation loads, detailed exposure diversity analysis, and room CFM estimates.',
                image: require('@/assets/img/content/hc-cooling-loads.png'),
            },
            {
                title: 'ACCA<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>-Approved Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>',
                description: 'HeatCAD MJ8 is ACCA-Approved for Manual J (8th Edition) residential heating and cooling load calculations. This streamlines the acceptance of your submittals by local authorities requiring ACCA-Approved software calculations. <a href="/acca">Click here</a> for more details.',
                image: require('@/assets/img/content/acca-powered.png'),
            },
            {
                title: 'CSA<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> F280-12 Residential Heating and Cooling Loads',
                description: 'HeatCAD provides for easy, accurate and verified <span class="bold">CSA F280-12</span> residential heating and cooling load calculations. <a href="/f280">Click here</a> for more details.',
                image: require('@/assets/img/content/f280-verified.png'),
            },
            {
                title: '3D CAD Views',
                description: 'HeatCAD generates 3D views of your building that you draw in 2D. The new 3D views are a powerful aide for ensuring accurate heat load calculations, and are also very effective for communicating your design work. Validation of the placement and sizing of windows, doors and walls is made much faster and more precise with the 3D views.',
                image: require('@/assets/img/content/hc-3dview.png'),
            },
        ],
    },
    PlumbingCAD: {
        name: 'PlumbingCAD',
        logo: require('@/assets/img/logos/product/plumbingcad.png'),
        year: 2021,
        page: '/product/plumbingcad',
        isAnnualSubscription: true,
        options: {
            new: [
                { label: 'Purchase and Activate a new annual subscription', value: 'newLicense' },
            ],
            renew: [
                { label: 'Renew my annual subscription', value: 'renew' },
            ],
            reactivate: [
                { label: 'Activate after a reinstall or after a version upgrade', value: 'reactivate' },
            ]
        },
        sysReq: {
            system: 'Microsoft Windows 11 or 10, with Microsoft .NET Framework 4.8',
            processor: '1.5 GHz or higher recommended',
            memory: '2 GB minimum, 8GB or more recommended',
            diskspace: '120 MB (Microsoft<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> .NET Framework may require up to 4.5 GB)',
            video: 'SVGA or higher (Recommend resolution of 1920x1080 or higher)',
            mouse: 'External mouse with scroll wheel (built-in mouse pads are not recommended)',
        },
        featureDescription: 'A true CAD-based software, PlumbingCAD lets you quickly import PDF or AutoCAD drawings, trace the plumbing system and then generate PEX-based materials lists and quotations. You also get 3-D views instantly as you define the system in 2-D, making it easier to visualize and communicate your work. The reports and drawing printouts greatly assist with approvals and installations. PlumbingCAD is an essential productivity tool for your PEX plumbing system work.',
        features: [
            {
                title: 'Import PDF and AutoCAD Drawings',
                description: 'PlumbingCAD lets you import existing plumbing system drawings, and there is no need to redraw the floorplan. You save hours of design time by simply defining the plumbing system over the imported drawing. Import AutoCAD, PDF or JPG drawings for use as the template for your plumbing system definition.',
                image: require('@/assets/img/content/pcad-import-pdf.png'),
            },
            {
                title: 'Quickly Trace Plumbing System',
                description: 'Add fixtures, multi-port tees, piping and risers to quickly define the plumbing system. Piping can be shown as rigid or flexible, and sizing is automatically set to match the connected fixtures.',
                image: require('@/assets/img/content/pcad-define-system.png'),
            },
            {
                title: '3D Views',
                description: 'Generate 3D views of the plumbing system that you define in 2D. The 3D views are a powerful aid for ensuring accuracy, and can be exported as image files.',
                image: require('@/assets/img/content/pcad-3dview.png'),
            },
            {
                title: 'Special Analysis Views',
                description: 'Several special analysis views are available to help in your review and analysis of your design work. Use these views to highlight hot piping only, cold piping only, specific pipe sizes or fixture types.',
                image: require('@/assets/img/content/pcad-analysis-views.png'),
            },
            {
                title: 'Materials Lists and Quotations',
                description: 'PlumbingCAD will automatically generate a detailed materials list based on your plumbing system design. Customize the included products, quantities and prices, and then generate a detailed Quotation document that can be exported to PDF.',
                image: require('@/assets/img/content/pcad-materials.png'),
            },
        ],
    },
    LengthWise: {
        name: 'LengthWise',
        logo: require('@/assets/img/logos/product/lengthwise.png'),
        year: 2014,
        page: '/product/lengthwise',
        isAnnualSubscription: false,
        sysReq: {
            system: 'Microsoft Windows 10, 8, or 7 (SP1), with Internet Explorer 6 or higher, with Microsoft<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> .NET Framework 2.0 or higher installed',
            processor: 'Pentium II minimum / 1.0 GHz or higher recommended',
            memory: '128 MB minimum / 256 MB or more recommended',
            diskspace: '10 MB minimum',
            video: 'SVGA or higher',
            mouse: '',
        }
    },
}
